import { useEffect } from 'react'

// Die alten Release Notes enden 2024. Produkt-Updates laufen jetzt ueber die
// oeffentliche Seite /product/updates. Voller Seitenwechsel statt <Navigate>,
// weil App.js oeffentliche Routen nur beim Laden der Seite erkennt.
const ReleaseNotesPage = () => {
  useEffect(() => {
    window.location.replace('/product/updates')
  }, [])

  return null
}

export default ReleaseNotesPage
